import { RequestActionType } from '@strata/react-chat';
import { DialogWithForm } from '@strata/react-dialog';
import { TextAreaFormik } from '@strata/react-inputs';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { handleError } from 'services/Error';
import { type PayerRequestActionDialogProps } from 'services/interfaces';
import { usePostRequestActivityMutation } from 'store/api/payerRequestApi';

const Title = 'Add/Update Summary';

export const UpdateSummaryDialog = ({
    onClose,
    payerId,
    requestDetails,
}: PayerRequestActionDialogProps) => {
    const [postRequestActivity] = usePostRequestActivityMutation();
    return (
        <Formik
            initialValues={{ summary: requestDetails.summary }}
            enableReinitialize
            validateOnMount
            validationSchema={Yup.object({ summary: Yup.string().required() })}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await postRequestActivity({
                        payerId,
                        requestId: requestDetails.requestId,
                        actionType: RequestActionType.SUMMARY_UP,
                        actionDetail: values.summary,
                    }).unwrap();

                    SuccessToast({ message: 'Request summary updated successfully.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError(
                        'Unable to update request summary. Please try again.',
                        err as Error,
                    );
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={600}
                    isOpen
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Update Summary"
                    isPrimaryButtonDisabled={
                        !(formik.isValid && formik.dirty) || formik.isSubmitting
                    }
                    dialogContent={<TextAreaFormik id="summary" label="Summary" required />}
                />
            )}
        </Formik>
    );
};

UpdateSummaryDialog.Title = Title;
